module.exports = __webpack_public_path__ + "963eb32907744d9a0d6b98127162808f.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/Light/OpenSans-Light.woff?v=1.1.0
// module id = 974
// module chunks = 0